module.exports = __webpack_public_path__ + "static/media/asolomon.695d978e.jpg";